/**
 * Formata valor como moeda brasileira (R$ X,XX)
 * @param {number|string} value - Valor a ser formatado
 * @returns {string} Valor formatado (ex: "R$ 2,50")
 */
export const formatCurrency = (value) => {
  if (value === null || value === undefined) return 'R$ 0,00';
  const numValue = typeof value === 'string' ? parseFloat(value) : value;
  if (isNaN(numValue)) return 'R$ 0,00';
  return numValue.toLocaleString('pt-BR', {
    style: 'currency',
    currency: 'BRL',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
};

export const toCents = (value) => {
  const amount = Number(value);
  return Number.isFinite(amount) ? Math.round((amount + Number.EPSILON) * 100) : null;
};

export const fromCents = (cents) => cents / 100;
